export default "__VITE_ASSET__DcYyb0P0__"